import { useEffect } from 'react'
import { Route, Routes, useNavigate } from 'react-router-dom'
import { useAuth } from '../components/auth/useAuth'
import MenuCommercial from '../components/menus/MenuCommercial'
import Sidebar from '../components/menus/Sidebar'
import TopBar from '../components/menus/TopBar'
import i18n from 'i18next'
import NothingHere from '../pages/error/NothingHere'

import Dashboard from '../pages/commercial/Dashboard'
import Clients from '../pages/Clients'
import Policies from '../pages/Policies'
import Sinesters from '../pages/Sinesters'
import Receipts from '../pages/Receipts'
import Documents from '../pages/Documents'
import ClientDetail from '../pages/ClientDetail'
import PolicyDetail from '../pages/PolicyDetail'
import SinesterDetail from '../pages/SinesterDetail'
import ReceiptDetail from '../pages/ReceiptDetail'

const t = i18n.t.bind(i18n)

export default function CommercialRouter() {
	const navigate = useNavigate()
	const { clientauth } = useAuth()

	useEffect(() => {
		let token = localStorage.getItem('jwt')

		if (!token) {
			navigate(`/${t("url.auth.login")}`)
		}
	}, [navigate])

	const commercialRoutesAlias = {
		"": "calendar",
		[t("url.dashboard")]: "dashboard",
		[t("url.clients")]: "clients",
		[`${t("url.clients")}/:id`]: "clientDetail",
		[t("url.policies")]: "policies",
		[`${t("url.policies")}/:id`]: "policyDetail",
		[t("url.sinesters")]: "sinesters",
		[`${t("url.sinesters")}/:id`]: "sinesterDetail",
		[t("url.receipts")]: "receipts",
		[`${t("url.receipts")}/:id`]: "receiptDetail",
		[t("url.documents")]: "documents"
	}

	const getComponentCommercial = (path: string) => {
		switch (path) {
			case "dashboard": return <Dashboard />;
			case "clients": return <Clients />;
			case "clientDetail": return <ClientDetail />;
			case "policies": return <Policies />;
			case "policyDetail": return <PolicyDetail />;
			case "sinesters": return <Sinesters />;
			case "sinesterDetail": return <SinesterDetail />;
			case "receipts": return <Receipts />;
			case "receiptDetail": return <ReceiptDetail />;
			case "documents": return <Documents />;
			default: return <NothingHere />;
		}
	}

	return (
		<div className="app-shell">
			<TopBar rol={clientauth?.rol ?? ""} />
			<div className="app-shell__body">
				<Sidebar rol={clientauth?.rol ?? ""} />
				<div className="app-content py-4 py-lg-5">
					<MenuCommercial />
					<Routes>
						{Object.entries(commercialRoutesAlias).map(([alias, path]) => (
							<Route key={alias} path={alias} element={getComponentCommercial(path)} />
						))}
						<Route path="*" element={<NothingHere />} />
					</Routes>
				</div>
			</div>
		</div>
	)
}